// Visit-report FINAL-refusal vocabulary — the codes and labels a refused write is named by.
//
// Extracted from missionVisitReports.ts as one cohesive unit: the v8 door's coded refusals and
// the label a rep can quote for any final refusal. Neither depends on the door clients, so they
// live apart from them; missionVisitReports.ts re-exports both (the public import path is unchanged).

// The v8 door's FINAL refusals (SL #2682): not the caller's mission, stop not on the mission, stop not
// found. Since the classifier inversion (retryClassification) EVERY 403/404 is final by status on every
// door; these codes are kept BY CODE for the rep copy that names the reason (the v8 sinks). Not in the
// generated wire types yet; defined here once, next to the door's client.
export const VISIT_REPORT_V8_MISSION_NOT_CALLERS = 'VISIT_REPORT_V8_MISSION_NOT_CALLERS'
export const VISIT_REPORT_V8_STOP_NOT_ON_MISSION = 'VISIT_REPORT_V8_STOP_NOT_ON_MISSION'
export const VISIT_REPORT_V8_STOP_NOT_FOUND = 'VISIT_REPORT_V8_STOP_NOT_FOUND'
export const VISIT_REPORT_V8_FINAL_REFUSAL_CODES = [
  VISIT_REPORT_V8_MISSION_NOT_CALLERS,
  VISIT_REPORT_V8_STOP_NOT_ON_MISSION,
  VISIT_REPORT_V8_STOP_NOT_FOUND,
] as const
export type VisitReportV8FinalRefusalCode = (typeof VISIT_REPORT_V8_FINAL_REFUSAL_CODES)[number]

/** The final-refusal code a failed v8 door call carries (withWrappedError keeps the envelope's
 *  `.code`), or null when it is any other failure. */
export function visitReportV8FinalRefusalCodeOf(err: unknown): VisitReportV8FinalRefusalCode | null {
  const code = (err as { code?: unknown } | null | undefined)?.code
  const found = VISIT_REPORT_V8_FINAL_REFUSAL_CODES.find((c) => c === code)
  return found === undefined ? null : found
}

/** The code a rep can quote for a FINAL refusal on either door: `HTTP <status> <CODE>` (what withWrappedError
 *  keeps), the part that exists, else the error's name — never empty, never a value from the body. */
export function visitReportRefusalLabelOf(err: unknown): string {
  const e = err as { status?: unknown; code?: unknown; name?: unknown } | null | undefined
  const status = typeof e?.status === 'number' ? `HTTP ${e.status}` : null
  const code = typeof e?.code === 'string' && e.code !== '' ? e.code : null
  const parts = [status, code].filter((p): p is string => p !== null)
  if (parts.length > 0) return parts.join(' ')
  return typeof e?.name === 'string' && e.name !== '' ? e.name : 'UNKNOWN_REFUSAL'
}
